import { asyncRouterMap, constantRouterMap } from '@/router/index';
import {buildMenu} from "../../api/login";
import Layout from "../../views/layout/Layout";

// // 判断是否有权限访问该菜单
// function hasPermission(menus, route) {
//   if (route.name) {
//     let currMenu = getMenu(route.name, menus);
//     if (currMenu!=null) {
//       //设置菜单的标题、图标和可见性
//       if (currMenu.title != null && currMenu.title !== '') {
//         route.meta.title = currMenu.title;
//       }
//       if (currMenu.icon != null && currMenu.title !== '') {
//         route.meta.icon = currMenu.icon;
//       }
//       if(currMenu.hidden!=null){
//         route.hidden = currMenu.hidden !== 0;
//       }
//       if (currMenu.sort != null && currMenu.sort !== '') {
//         route.sort = currMenu.sort;
//       }
//       return true;
//     } else {
//       route.sort = 0;
//       if (route.hidden !== undefined && route.hidden === true) {
//         return true;
//       } else {
//         return false;
//       }
//     }
//   } else {
//     return true
//   }
// }

//根据路由名称获取菜单
// function getMenu(name, menus) {
//   for (let i = 0; i < menus.length; i++) {
//     let menu = menus[i];
//     if (name===menu.name) {
//       return menu;
//     }
//   }
//   return null;
// }

//对菜单进行排序
// function sortRouters(accessedRouters) {
//   for (let i = 0; i < accessedRouters.length; i++) {
//     let router = accessedRouters[i];
//     if(router.children && router.children.length > 0){
//       router.children.sort(compare("sort"));
//     }
//   }
//   accessedRouters.sort(compare("sort"));
// }

// //降序比较函数
// function compare(p){
//   return function(m,n){
//     let a = m[p];
//     let b = n[p];
//     return b - a;
//   }
// }

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      }
      else {
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  let children = []
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView') {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

export const loadView = (view) => { // 路由懒加载
  return (resolve) => require([`@/views/${view}`], resolve)
}

const permission = {
  state: {
    routers: [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        buildMenu().then(res =>{
          //对菜单进行排序
          // sortRouters(res.data);
          commit('SET_ROUTERS', filterAsyncRouter(res.data));
          resolve();
        })
      })
    }
  }
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js